import { useCallback, useState } from 'react'

export const useTriggerOnce = () => {
  const [hasTriggered, setHasTriggered] = useState(false)

  const triggerOnce = useCallback(
    (cb: () => void) => {
      if (hasTriggered) return

      setHasTriggered(true)
      cb()
    },
    [hasTriggered]
  )

  return [triggerOnce, hasTriggered] as const
}
